import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ProductPaymentPage } from './product-payment.page';

const routes: Routes = [
  {
    path: '',
    component: ProductPaymentPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ProductPaymentPageRoutingModule {}
